import { Dropdown } from 'src/app/shared/models/dropdown.model';
import { UserDetails } from './../models/userDetail.model';
import * as moment from "moment";

export function convertUTCDateToLocalDateMMDDYYYYHHMMSS(stringDate): string {
  const tempDate = new Date(stringDate);
  const date = new Date(
    tempDate.getTime() - tempDate.getTimezoneOffset() * 60 * 1000
  );
  let month = String(date.getMonth() + 1);
  let day = String(date.getDate());
  const year = String(date.getFullYear());
  let hour = String(date.getHours());
  let min = String(date.getMinutes());
  let sec = String(date.getSeconds());

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  if (hour.length < 2) {
    hour = '0' + hour;
  }
  if (min.length < 2) {
    min = '0' + min;
  }
  if (sec.length < 2) {
    sec = '0' + sec;
  }

  return `${day}/${month}/${year} ${hour}:${min}:${sec}`;
}

export function momentDatetoUTCFormat(date: string): string {
  return moment(date).utc().format('DD/MM/YYYY HH:mm:ss');
}

export function dateStringToUTCFormat(date: string): string {
  const dateStr = date.split('/');
  return moment(new Date(`${dateStr[1]}-${dateStr[0]}-${dateStr[2]}`).toString()).utc().format('YYYY-MM-DDTHH:mm:ss.SS');
}

export function convertUTCDateToLocalDateDDMMYYYY(stringDate): string {
  const tempDate = new Date(stringDate);
  const date = new Date(
    tempDate.getTime() - tempDate.getTimezoneOffset() * 60 * 1000
  );
  let month = String(date.getMonth() + 1);
  let day = String(date.getDate());
  const year = String(date.getFullYear());

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return `${day}/${month}/${year}`;
}

export function checkForNull(dataVal: any): any {
  for (let key of Object.keys(dataVal)) {
    if (dataVal[key] === '-1' || dataVal[key] === '') {
      dataVal[key] = null;
    }
  }
  return dataVal;
}

export function base64ToArrayBuffer(base64): Uint8Array {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    let ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function saveByteArray(data, name): void {
  let a = document.createElement('a');
  document.body.appendChild(a);
  // a.style = 'display: none';
  const blob = new Blob(data, { type: 'octet/stream' });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = name;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};

export function sortUsersByFirstName(user1: UserDetails, user2: UserDetails): any {
  const item1 = user1.firstName ? user1.firstName.toUpperCase() : '';
  const item2 = user2.firstName ? user2.firstName.toUpperCase() : '';
  if (item1 < item2) {
    return -1;
  } else if (item1 > item2) {
    return 1;
  }
  return 0;
}

export function sortDropdownByName(dropdown1: Dropdown, dropdown2: Dropdown): any {
  const item1 = dropdown1.dropdownDesc ? dropdown1.dropdownDesc.toUpperCase() : '';
  const item2 = dropdown2.dropdownDesc ? dropdown2.dropdownDesc.toUpperCase() : '';
  if (item1 < item2) {
    return -1;
  } else if (item1 > item2) {
    return 1;
  }
  return 0;
}

export function sortDropdownBydropdownOrder(dropdown1: Dropdown, dropdown2: Dropdown): any {
  if (dropdown1.dropdownOrder < dropdown2.dropdownOrder) {
    return -1;
  } else if (dropdown1.dropdownOrder > dropdown2.dropdownOrder) {
    return 1;
  }
  return 0;
}

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

/**
*
* @description used to check file with same file name
* @param {*} data
* @param {File} formFileValue
* @return {*}  {boolean}
* @memberof CreateUpdateUploadComponent
*/
export function checkForSameFile(data, formFileValue: File): boolean {
  if (!data) {
    return true;
  }
  const index = data.findIndex((x) => x.fileName === formFileValue.name);
  if (index > -1) {
    return false;
  }
  return true;
}

/**
 *
 *
 * @param {*} bytes
 * @param {number} [decimals=2]
 * @return {*} 
 */
export function formatBytes(bytes, decimals = 2): any {
  if (bytes === 0) {
    return '0 Bytes';
  }
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
